/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { QaEquipmentRtSystemDto } from './QaEquipmentRtSystemDto';
import {
    QaEquipmentRtSystemDtoFromJSON,
    QaEquipmentRtSystemDtoFromJSONTyped,
    QaEquipmentRtSystemDtoToJSON,
} from './QaEquipmentRtSystemDto';

/**
 * 
 * @export
 * @interface ODataPostProcessedResultsOfQaEquipmentRtSystemDto
 */
export interface ODataPostProcessedResultsOfQaEquipmentRtSystemDto {
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfQaEquipmentRtSystemDto
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<QaEquipmentRtSystemDto>}
     * @memberof ODataPostProcessedResultsOfQaEquipmentRtSystemDto
     */
    value?: Array<QaEquipmentRtSystemDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ODataPostProcessedResultsOfQaEquipmentRtSystemDto
     */
    $type?: ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ODataPostProcessedResultsOfQaEquipmentRtSystemDto
     */
    odataCount?: number;
}


/**
 * @export
 */
export const ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedCommonDtoODataPostProcessedResults1PtwPtw100AppZeroApplicationSharedDeviceComponentDtoQaEquipmentRtSystemDtoPtwPtw100AppZeroApplicationSharedPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Common.Dto.ODataPostProcessedResults`1[[Ptw.Ptw100.AppZero.Application.Shared.DeviceComponent.Dto.QaEquipmentRtSystemDto, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum = typeof ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum[keyof typeof ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum];


/**
 * Check if a given object implements the ODataPostProcessedResultsOfQaEquipmentRtSystemDto interface.
 */
export function instanceOfODataPostProcessedResultsOfQaEquipmentRtSystemDto(value?: unknown): value is ODataPostProcessedResultsOfQaEquipmentRtSystemDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ODataPostProcessedResultsOfQaEquipmentRtSystemDtoTypeEnum)[0];
}

export function ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSON(json: any): ODataPostProcessedResultsOfQaEquipmentRtSystemDto {
    return ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSONTyped(json, false);
}

export function ODataPostProcessedResultsOfQaEquipmentRtSystemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ODataPostProcessedResultsOfQaEquipmentRtSystemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'value': !exists(json, 'value') ? undefined : (json['value'] === null ? null : (json['value'] as Array<any>).map(QaEquipmentRtSystemDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
        'odataCount': !exists(json, '@odata.count') ? undefined : json['@odata.count'],
    };
}

export function ODataPostProcessedResultsOfQaEquipmentRtSystemDtoToJSON(value?: ODataPostProcessedResultsOfQaEquipmentRtSystemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'totalCount': value.totalCount,
        'value': value.value === undefined ? undefined : (value.value === null ? null : (value.value as Array<any>).map(QaEquipmentRtSystemDtoToJSON)),
        '$type': value.$type,
        '@odata.count': value.odataCount,
    });
}

